/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect, useState } from "react";
import { Vocabulary } from "../../Utils/Vocabulary";
import GenericModal from "../GenericComponents/GenericModal";
import OrdersAutocomplete from "./OrdersAutocomplete";
import { Autocomplete, TextField } from "@mui/material";

type AssignToOrderModalProps = {
  open: boolean;
  onClose: () => void;
  timeTracking: any;
};
export default function AssignToOrderModal(props: AssignToOrderModalProps) {
  const { open, onClose, timeTracking } = props;
  const [currentTimeTracking, setCurrentTimeTracking] = useState<any>(null);

  useEffect(() => {
    setCurrentTimeTracking(timeTracking);
  }, [timeTracking]);

  /**
   *
   * @param event
   * @param value
   */
  function handleChangeOrderAutocomplete(event: any, value: any) {
    setCurrentTimeTracking({
      ...currentTimeTracking,
      orderId: value,
      stepId: null,
    });
  }
  return (
    <>
      {currentTimeTracking ? (
        <GenericModal
          open={open}
          onClose={onClose}
          title={Vocabulary.assignToOrder}
          styleDialogPaper={{
            width: "100%",
            maxWidth: "900px",
            height: "60vh",
          }}
        >
          <OrdersAutocomplete
            parentOrder={currentTimeTracking.orderId}
            handleChangeOrderInParent={(event: any, value: any) =>
              handleChangeOrderAutocomplete(event, value)
            }
          />
          <Autocomplete
            size="small"
            id="step"
            freeSolo={false}
            disablePortal
            disabled={!currentTimeTracking.orderId}
            getOptionLabel={(option: any) => {
              return option.stepId.name;
            }}
            isOptionEqualToValue={(option, value) => option._id === value._id}
            options={
              currentTimeTracking.orderId
                ? currentTimeTracking.orderId.workflowSteps
                : []
            }
            value={currentTimeTracking.stepId}
            onChange={(event: any, value: any) =>
              setCurrentTimeTracking({ ...currentTimeTracking, stepId: value })
            }
            style={{ marginTop: "20px" }}
            renderInput={(params) => (
              <TextField
                {...params}
                name="step"
                label={Vocabulary.step}
                variant="outlined"
              />
            )}
          />
        </GenericModal>
      ) : null}
    </>
  );
}
